import { motion } from 'framer-motion';

interface GlitchTextProps {
  text: string;
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'span' | 'p';
}

export default function GlitchText({ text, className = '', as: Component = 'h1' }: GlitchTextProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="relative inline-block"
    >
      <Component
        className={`glitch font-orbitron ${className}`}
        data-text={text}
      >
        {text}
      </Component>
    </motion.div>
  );
}

